import { RadarSplash } from './BootRadar';

/* 2026-09-26 (design wave) · the session-check loader is the same CSS-3D radar
   the index.html load splash paints, so the HTML-to-React handoff is one
   continuous screen. Was a lone 6px pulsing dot (2026-05-26), which read as a
   different app for the half second between the splash and the landing. */
export function Splash({ label }: { label: string }) {
  return <RadarSplash label={label} />;
}
